type MaybeObject<T> = T | null | undefined

function isEmpty(str: MaybeObject<string>): boolean {
  if (str === null || str === undefined) {
    return true
  }
  return str.trim() === ''
}

function isNotEmpty(str: MaybeObject<string>): boolean {
  return !isEmpty(str)
}

function convertPxFromNumber(px: number): string {
  return `${px}px`
}

function formatThreeDigitNumber(value: number | string): string {
  if (typeof value === 'number') {
    return value.toLocaleString()
  }

  const numberValue = Number(value)

  if (isNaN(numberValue)) {
    return 'NaN'
  }

  return numberValue.toLocaleString()
}

export const stringUtils = {
  isEmpty,
  isNotEmpty,
  convertPxFromNumber,
  formatThreeDigitNumber,
}
